/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/
import { useGLTF } from '@react-three/drei';

type Props = {
  pos: Array<number>;
  scale?: number;
  rot: Array<number>;
};

export default function Palace({ pos, scale = 1, rot }: Props) {
  const { scene } = useGLTF('special/palace.glb');
  return (
    <group
      position={[pos[0], pos[1], pos[2]]}
      scale={scale}
      rotation={[rot[0], rot[1], rot[2]]}
    >
      <primitive object={scene} />
    </group>
  );
}
